type ProjectsTransferError = {
  areZonesEquals: boolean;
  hasUnExpectedError: boolean;
  message: string;
};

const projectsTransferError: ProjectsTransferError = {
  areZonesEquals: false,
  hasUnExpectedError: false,
  message: "",
};

export type { ProjectsTransferError };

export { projectsTransferError };
